import { defineStore } from 'pinia';
import http from './http';
import { Response } from '@/types';
import { useAuthStore } from '@/plugins';
import { useLoadingStore } from './loading';

export interface Profile {
  account: Account;
  permissions: string[];
  role: string;
}
export interface Account {
  username: string;
  avatar: string;
  gender: number;
}

export type TokenResult = {
  token: string;
  expires: number;
};
export const useAccountStore = defineStore('account', {
  state() {
    return {
      account: {} as Account,
      permissions: [] as string[],
      role: '',
      logged: true,
    };
  },
  actions: {
    async getCaptcha(mobile: string) {
      return http
        .request<TokenResult, Response<TokenResult>>('system/sms-captcha', 'get', { mobile, type: 'LOGIN' })
        .then(async (response) => {
          if (response.code === '0000') {
            return response.data;
          } else {
            return Promise.reject(response);
          }
        });
    },
    async login(mobile: string, password: string) {
      return http
        .request<TokenResult, Response<TokenResult>>('jpfs/login', 'post_json', { mobile, password })
        .then(async (response) => {
          if (response.code === '0000') {
            this.logged = true;
            http.setAuthorization(`${response.data}`, new Date(response.data.expires));
            return response.data;
          } else {
            return Promise.reject(response);
          }
        });
    },
    async logout() {
      return new Promise<boolean>((resolve) => {
        localStorage.removeItem('stepin-menu');
        http.removeAuthorization();
        this.logged = false;
        resolve(true);
      });
    },
    async profile() {
      const { setAuthLoading } = useLoadingStore();
      setAuthLoading(true);
      return http
        .request<Account, Response<Profile>>('/account', 'get')
        .then((response) => {
          if (response.code === '0000') {
            const { setAuthorities } = useAuthStore();
            const { account, permissions, role } = response.data;
            this.account = account;
            this.permissions = permissions;
            this.role = role;
            setAuthorities(permissions);
            return response.data;
          } else {
            return Promise.reject(response);
          }
        })
        .finally(() => setAuthLoading(false));
    },
    setLogged(logged: boolean) {
      this.logged = logged;
    },
  },
});
